<div class="modal-root">

  <!-- ─── Header ─── -->
  <div class="modal-header">
    <div class="header-text">
      <h2 class="header-title">
        <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">account_balance_wallet</mat-icon>
        Crear Wallet
      </h2>
      <p class="header-subtitle">
        {{ userDisplayName() }} <span *ngIf="userDisplayId()">— {{ userDisplayId() }}</span>
      </p>
    </div>
    <button class="close-btn" type="button" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ─── Card: Estado actual ─── -->
  <div class="status-card">
    <span class="card-label">Estado actual</span>
    <div class="status-grid">
      <div class="status-row">
        <span class="status-key">Subcuenta</span>
        <span class="status-chip"
          [style.background]="user.walletStatus ? walletStatusColor(user.walletStatus) + '22' : '#f3f4f6'"
          [style.color]="walletStatusColor(user.walletStatus)">
          {{ walletStatusLabel(user.walletStatus) }}
        </span>
        <span class="status-meta" *ngIf="user.subAccountId">subId: {{ user.subAccountId }}</span>
      </div>

      <div class="status-row">
        <span class="status-key">KYC</span>
        <span class="status-chip"
          [style.background]="user.kycStatus ? kycStatusColor(user.kycStatus) + '22' : '#f3f4f6'"
          [style.color]="kycStatusColor(user.kycStatus)">
          {{ kycStatusLabel(user.kycStatus) }}
        </span>
        <span class="status-meta" *ngIf="user.kycStatus">(Binance: {{ user.kycStatus }})</span>
      </div>

      <div class="status-row">
        <span class="status-key">Wallet TRC20</span>
        <span class="status-chip"
          [style.background]="isWalletDone ? '#dcfce7' : '#f3f4f6'"
          [style.color]="isWalletDone ? '#15803d' : '#6b7280'">
          {{ isWalletDone ? 'Creada' : 'No creada' }}
        </span>
      </div>
    </div>
  </div>

  <!-- ─── Checklist KYC (campos textuales + fotos) ─── -->
  <div *ngIf="kycChecklist" class="step-card kyc-card">
    <div class="step-header">
      <span class="step-num kyc-tag">KYC data</span>
      <span class="step-title">Datos para Binance KYC</span>
      <span class="status-chip kyc-readiness-chip"
        [style.background]="kycChecklist.isReady ? '#dcfce7' : '#fee2e2'"
        [style.color]="kycChecklist.isReady ? '#15803d' : '#b91c1c'">
        <mat-icon class="btn-icon" style="font-size: 14px; width: 14px; height: 14px;">
          {{ kycChecklist.isReady ? 'check_circle' : 'error' }}
        </mat-icon>
        {{ kycChecklist.isReady ? 'Listo' : kycChecklist.totalMissing + ' faltante(s)' }}
      </span>
    </div>
    <p class="step-desc">
      Campos y fotos que se enviarán a Binance KYC SaaS en el paso 1. Los <strong>requeridos</strong>
      faltantes bloquean la creación de subcuenta — los opcionales son solo informativos.
    </p>

    <!-- Grilla OK/falta -->
    <div class="kyc-grid">
      <!-- Datos cargados (OK) -->
      <div class="kyc-section">
        <div class="kyc-section-header kyc-section-ok">
          <mat-icon class="btn-icon">check_circle</mat-icon>
          Cargados ({{ kycChecklist.ok.length }})
        </div>
        <ul class="kyc-list">
          <li *ngFor="let item of kycChecklist.ok" class="kyc-list-item">
            <span class="kyc-list-label">{{ item.label }}</span>
            <span class="kyc-list-value">{{ item.value || '✓' }}</span>
          </li>
          <li *ngIf="kycChecklist.ok.length === 0" class="kyc-list-empty">Ningún campo cargado.</li>
        </ul>
      </div>

      <!-- Datos faltantes (requeridos) -->
      <div class="kyc-section">
        <div class="kyc-section-header"
          [class.kyc-section-missing]="kycChecklist.missing.length > 0"
          [class.kyc-section-ok-empty]="kycChecklist.missing.length === 0">
          <mat-icon class="btn-icon">{{ kycChecklist.missing.length > 0 ? 'cancel' : 'check_circle' }}</mat-icon>
          Faltantes requeridos ({{ kycChecklist.missing.length }})
        </div>
        <ul class="kyc-list">
          <li *ngFor="let label of kycChecklist.missing" class="kyc-list-item kyc-list-item-missing">
            <mat-icon class="btn-icon" style="font-size: 12px; width: 12px; height: 12px;">close</mat-icon>
            {{ label }}
          </li>
          <li *ngIf="kycChecklist.missing.length === 0" class="kyc-list-empty">
            Todos los requeridos están cargados.
          </li>
        </ul>

        <div *ngIf="kycChecklist.missingOptional.length > 0" class="kyc-optional">
          <span class="kyc-optional-label">Opcionales sin cargar:</span>
          <span class="kyc-optional-list">{{ kycChecklist.missingOptional.join(', ') }}</span>
        </div>
      </div>
    </div>

    <!-- Tira de thumbnails -->
    <div class="kyc-photos-strip">
      <div class="kyc-photo-cell"
        *ngFor="let photo of kycChecklist.photos"
        [class.kyc-photo-missing-required]="!photo.url && photo.required"
        [class.kyc-photo-missing-optional]="!photo.url && !photo.required">
        <div class="kyc-photo-label">
          {{ photo.label }}
          <span *ngIf="!photo.required" class="kyc-photo-optional-tag">opcional</span>
        </div>

        <div class="kyc-photo-frame">
          <ng-container *ngIf="photo.url; else photoMissing">
            <img [src]="photo.url" [alt]="photo.label" (error)="onPhotoError($event)" />
            <div class="kyc-photo-fallback" style="display: none;">
              <mat-icon>broken_image</mat-icon>
              <span>No disponible</span>
            </div>
          </ng-container>
          <ng-template #photoMissing>
            <div class="kyc-photo-empty"
              [class.kyc-photo-empty-required]="photo.required">
              <mat-icon>{{ photo.required ? 'image_not_supported' : 'image' }}</mat-icon>
              <span>{{ photo.required ? 'Falta' : 'Sin cargar' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Prevalidación KYC interna (Aguacate) ─── -->
  <div class="step-card prevalidation-card">
    <div class="step-header">
      <span class="step-num prevalidation-tag">Pre-check</span>
      <span class="step-title">Prevalidación KYC Aguacate</span>
      <span class="status-chip prevalidation-chip"
        [style.background]="prevalidationBadgeColor().bg"
        [style.color]="prevalidationBadgeColor().fg">
        <mat-icon *ngIf="prevalidationState === 'LOADING'" class="btn-icon spin" style="font-size: 14px; width: 14px; height: 14px;">refresh</mat-icon>
        {{ prevalidationBadgeLabel() }}
      </span>
    </div>
    <p class="step-desc">
      Re-corre OCR fresco sobre el documento y verifica facial selfie ↔ documento contra
      los KYC services internos. Recomendado antes de enviar a Binance.
    </p>

    <!-- Detalle del run fresco para ESTE usuario -->
    <div *ngIf="hasFreshPrevalidation" class="prevalidation-detail">
      <div class="prevalidation-row">
        <span class="prevalidation-key">Facial</span>
        <span class="prevalidation-value">{{ prevalidationFaceLabel }}</span>
      </div>
      <div class="prevalidation-row">
        <span class="prevalidation-key">OCR</span>
        <span class="prevalidation-value">{{ prevalidationOcrLabel }}</span>
      </div>
      <div class="prevalidation-row">
        <span class="prevalidation-key">Validado</span>
        <span class="prevalidation-value">
          {{ prevalidationDate | date:'short' }}
          <span *ngIf="prevalidationFromCache" class="prevalidation-cache-tag">desde caché</span>
        </span>
      </div>
    </div>

    <!-- Error / bloqueo -->
    <div *ngIf="prevalidationError" class="step-result"
      style="background: #fee2e2; color: #991b1b;">
      {{ prevalidationError }}
    </div>

    <!-- Botón revalidar -->
    <button type="button" class="step-btn"
      [class.btn-primary]="prevalidationState === 'IDLE' || prevalidationState === 'PARTIAL' || prevalidationState === 'FAIL' || prevalidationState === 'ERROR'"
      [class.btn-loading]="prevalidationState === 'LOADING'"
      [class.btn-done]="prevalidationState === 'OK'"
      [disabled]="!canRevalidate"
      [matTooltip]="prevalidationState === 'BLOCKED' ? (prevalidationError || 'Faltan fotos en el perfil del usuario') : ''"
      (click)="revalidatePrevalidation()">
      <mat-icon *ngIf="prevalidationState === 'LOADING'" class="btn-icon spin">refresh</mat-icon>
      <mat-icon *ngIf="prevalidationState === 'OK'" class="btn-icon">verified</mat-icon>
      <mat-icon *ngIf="prevalidationState !== 'LOADING' && prevalidationState !== 'OK' && prevalidationState !== 'BLOCKED'" class="btn-icon">policy</mat-icon>
      <mat-icon *ngIf="prevalidationState === 'BLOCKED'" class="btn-icon">block</mat-icon>

      <span *ngIf="prevalidationState === 'IDLE'">Revalidar ahora</span>
      <span *ngIf="prevalidationState === 'LOADING'">Revalidando...</span>
      <span *ngIf="prevalidationState === 'OK'">Prevalidación OK</span>
      <span *ngIf="prevalidationState === 'PARTIAL'">Reintentar revalidación</span>
      <span *ngIf="prevalidationState === 'FAIL'">Revalidar de nuevo</span>
      <span *ngIf="prevalidationState === 'BLOCKED'">No se puede revalidar</span>
      <span *ngIf="prevalidationState === 'ERROR'">Reintentar</span>
    </button>

    <!-- Aviso: prevalidación NO aprobada -->
    <div *ngIf="prevalidationState === 'FAIL' || prevalidationState === 'PARTIAL'"
      class="step-result"
      style="background: #fef9c3; color: #854d0e;">
      ⚠ Esta prevalidación no pasó. Podés continuar con el registro en Binance, pero
      Binance probablemente rechace el KYC con los mismos datos. Verificá las fotos antes.
    </div>
  </div>

  <!-- ─── Paso 1: Subcuenta + KYC ─── -->
  <div class="step-card">
    <div class="step-header">
      <span class="step-num">Paso 1</span>
      <span class="step-title">Subcuenta + KYC</span>
    </div>
    <p class="step-desc">
      La subcuenta crea la cuenta del usuario en Binance y envía sus datos KYC. El KYC se procesa en horas o días.
    </p>

    <button type="button" class="step-btn"
      [class.btn-primary]="onboardState === 'IDLE'"
      [class.btn-loading]="onboardState === 'LOADING'"
      [class.btn-done]="onboardState === 'DONE'"
      [class.btn-waiting]="onboardState === 'WAITING_KYC'"
      [class.btn-error]="onboardState === 'ERROR'"
      [class.btn-orange]="onboardState === 'KYC_REJECTED'"
      [disabled]="!canSubmitOnboard"
      (click)="registrarSubcuenta()">
      <mat-icon *ngIf="onboardState === 'IDLE'" class="btn-icon">person_add</mat-icon>
      <mat-icon *ngIf="onboardState === 'LOADING'" class="btn-icon spin">refresh</mat-icon>
      <mat-icon *ngIf="onboardState === 'DONE'" class="btn-icon">check_circle</mat-icon>
      <mat-icon *ngIf="onboardState === 'WAITING_KYC'" class="btn-icon spin">hourglass_top</mat-icon>
      <mat-icon *ngIf="onboardState === 'ERROR'" class="btn-icon">refresh</mat-icon>
      <mat-icon *ngIf="onboardState === 'KYC_REJECTED'" class="btn-icon">restart_alt</mat-icon>

      <span *ngIf="onboardState === 'IDLE'">Registrar Subcuenta</span>
      <span *ngIf="onboardState === 'LOADING'">Procesando...</span>
      <span *ngIf="onboardState === 'DONE'">Ya registrada</span>
      <span *ngIf="onboardState === 'WAITING_KYC'">Esperando KYC...</span>
      <span *ngIf="onboardState === 'ERROR'">Reintentar</span>
      <span *ngIf="onboardState === 'KYC_REJECTED'">Reenviar KYC</span>
    </button>

    <div *ngIf="onboardMessage" class="step-result"
      [style.background]="onboardMessageBgColor()"
      [style.color]="onboardMessageTextColor()">
      {{ onboardMessage }}
    </div>

    <button *ngIf="onboardState === 'WAITING_KYC'" type="button" class="link-btn" (click)="refreshStatus()">
      <mat-icon class="link-icon">sync</mat-icon> Refrescar estado manualmente
    </button>
  </div>

  <!-- ─── Paso 2: Wallet TRC20 ─── -->
  <div class="step-card">
    <div class="step-header">
      <span class="step-num">Paso 2</span>
      <span class="step-title">Wallet USDT TRC20</span>
    </div>
    <p class="step-desc">
      Genera la dirección para que el usuario reciba USDT en red TRON. Solo disponible cuando el KYC esté aprobado.
    </p>

    <button type="button" class="step-btn"
      [class.btn-primary]="walletState === 'IDLE'"
      [class.btn-loading]="walletState === 'LOADING'"
      [class.btn-done]="walletState === 'DONE_CACHED' || walletState === 'DONE_FRESH'"
      [class.btn-error]="walletState === 'ERROR'"
      [disabled]="!canCreateWallet"
      [matTooltip]="walletState === 'DISABLED_NO_KYC' ? 'El usuario se encuentra pendiente de aprobación de KYC' : ''"
      (click)="crearWallet()">
      <mat-icon *ngIf="walletState === 'IDLE'" class="btn-icon">add_circle</mat-icon>
      <mat-icon *ngIf="walletState === 'LOADING'" class="btn-icon spin">refresh</mat-icon>
      <mat-icon *ngIf="isWalletDone" class="btn-icon">check_circle</mat-icon>
      <mat-icon *ngIf="walletState === 'ERROR'" class="btn-icon">refresh</mat-icon>
      <mat-icon *ngIf="walletState === 'DISABLED_NO_SUB' || walletState === 'DISABLED_NO_KYC'" class="btn-icon">block</mat-icon>

      <span *ngIf="walletState === 'IDLE'">Crear Wallet</span>
      <span *ngIf="walletState === 'LOADING'">Procesando...</span>
      <span *ngIf="walletState === 'DONE_CACHED'">Wallet creada (cache)</span>
      <span *ngIf="walletState === 'DONE_FRESH'">Wallet creada</span>
      <span *ngIf="walletState === 'ERROR'">Reintentar</span>
      <span *ngIf="walletState === 'DISABLED_NO_SUB'">Requiere subcuenta activa</span>
      <span *ngIf="walletState === 'DISABLED_NO_KYC'">Requiere KYC aprobado</span>
    </button>

    <div *ngIf="trc20Address" class="address-block">
      <div class="address-line">
        <span class="address-label">Dirección:</span>
        <span class="address-value" [title]="trc20Address">{{ trc20Address }}</span>
        <button type="button" class="copy-btn" (click)="copyAddress()" title="Copiar dirección">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">content_copy</mat-icon>
        </button>
      </div>
      <div class="address-meta">
        <span>Red: <strong>TRC20 (Tron)</strong></span>
        <span *ngIf="trc20FetchedAt"> · obtenida {{ trc20FetchedAt | date:'short' }}</span>
      </div>
    </div>
  </div>

  <!-- ─── Footer ─── -->
  <div class="modal-footer">
    <button type="button" class="close-action" (click)="close()">Cerrar</button>
  </div>
</div>
